// import React,{useEffect} from "react";
// import { BrowserRouter } from "react-router-dom";
// import AppRouter from "../src/components/AppRouter"; // Adjust the path if needed
// import { BusinessProvider } from "./components/BusinessContext";
// import { AuthProvider} from './globals/AuthContext';
// function App() {

//   return (
//     <AuthProvider>
//    <BusinessProvider>
//      <BrowserRouter>
//       <AppRouter />
//     </BrowserRouter>
//    </BusinessProvider>
//   </AuthProvider>
//   );
// }

// export default App;

// App.js
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "../src/components/AppRouter";
import { BusinessProvider } from "./components/BusinessContext";
import { AuthProvider, useAuth } from "./globals/AuthContext";
import "./languagetranslate/i18n";
import { useEffect, useMemo, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createPointGenieTheme } from "./theme/pointgenieTheme";

function getSystemThemeMode() {
  if (typeof window === "undefined") return "light";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

const AppContent = () => {
  const { authReady } = useAuth();
  const [themeMode, setThemeMode] = useState(getSystemThemeMode);
  const theme = useMemo(() => createPointGenieTheme(themeMode), [themeMode]);

  useEffect(() => {
    document.documentElement.dataset.theme = themeMode;
    document.documentElement.style.colorScheme = themeMode;
  }, [themeMode]);

  useEffect(() => {
    const media = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!media) return undefined;

    const onSystemThemeChange = (event) => {
      setThemeMode(event.matches ? "dark" : "light");
    };

    media.addEventListener?.("change", onSystemThemeChange);
    return () => media.removeEventListener?.("change", onSystemThemeChange);
  }, []);

  if (!authReady) {
    return null; // or show a splash screen
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BusinessProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </BusinessProvider>
    </ThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
